import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { TipoProductoCategoriaComponent } from '../../tipo-producto-categoria/tipo-producto-categoria.component';
import { MAT_DIALOG_DATA, MatDialogRef, MatHorizontalStepper, MatSnackBar } from '@angular/material';
import { TipoProductoCategoriaService } from '../../../../../providers/tipo-producto-categoria.service';

export enum StepperTitulos {
  CARGA_DE_DATOS = 0,
  SUBIR_ARCHIVOS = 1,
  ABM_ARCHIVOS = 2
}

@Component({
  selector: 'app-crear-tipo-producto-categoria-dialog',
  templateUrl: './crear-tipo-producto-categoria-dialog.component.html',
  styleUrls: ['./crear-tipo-producto-categoria-dialog.component.scss']
})
export class CrearTipoProductoCategoriaDialog {
  error: string = '';
  cargando: boolean = false;
  IdCategoria?: number | string = null; // id del dato creado

  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;
  @ViewChild(TipoProductoCategoriaComponent) productoForm: TipoProductoCategoriaComponent; // accedemos al formulario de carga
  @ViewChild('dialogContent') dialogContent: ElementRef;

  constructor(
    public dialogCrear: MatDialogRef<CrearTipoProductoCategoriaDialog>,
    private tipoProductoCategoriaService: TipoProductoCategoriaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) { }

  onTipoProductoCategoriaInput() { // si cambian los datos ingresados
    this.error = ''; // limpiamos los mensajes de error del formulario
  }

  onFormState(formState: any): void { // escucha los diferentes estados del formulario
    if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
      this.error = formState.mensaje;
    }

    if (typeof formState.cargando != undefined) {
      this.cargando = formState.cargando;
    }
  }

  onCancelar(): void {
    this.dialogCrear.close();
  }

  // finalizar carga 
  onFinalizar(): void {
    this.dialogCrear.close();
  }

  onCrear(): void {
    this.error = '';

    try { // cacheo de errores antes de llamar al servidor
      this.cargando = true;
      this.tipoProductoCategoriaService.crearTipoProductoCategoria(this.productoForm.getTipoProductoCategoria()).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
            this.IdCategoria = respuesta.data.IdCategoria; // Id del dato creado
            this.dialogCrear.close(respuesta);
          } else {
            this.error = respuesta.mensaje;
          }

          this.cargando = false;
        },
        error => {
          this.cargando = false;
          this.error = error;
        });
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }
  }

  setCargando(estado) {
    this.cargando = estado;
  }


  scrollToBottom() {
    this.dialogContent.nativeElement.scrollTop = this.dialogContent.nativeElement.scrollHeight;
  }
}
